import React, { FC } from "react";
import { cls } from "@wss/cls";

import Single from "./variants/Single";
import Multi from "./variants/Multi";

import { TopperSection } from "../../types";

export interface StandardTopperProps {
  sections: TopperSection[];
  defaultSectionId?: number;
}

const Standard: FC<StandardTopperProps> = ({
  sections = [],
  defaultSectionId,
}) => {
  const defaultSection =
    sections.find(({ sectionId }) => sectionId === defaultSectionId)?.name ??
    sections[0]!.name;

  return (
    <div
      className={cls(
        "h-auto quick-filter p-4 collapse-animation",
        "sm:p-4",
        "md:p-6 md:px-[63px]",
      )}
      id="toppers"
      data-testid="toppers"
    >
      {(sections.length > 1 && (
        <Multi defaultSection={defaultSection} sections={sections} />
      )) || (
        <Single
          sectionId={sections[0]!.sectionId}
          displayType={sections[0]!.displayType}
          name={sections[0]!.name}
          items={sections[0]!.items}
        />
      )}
    </div>
  );
};

export default Standard;
